import { render, staticRenderFns } from "./chainAdministrationDetails.vue?vue&type=template&id=706a0808&"
import script from "./chainAdministrationDetails.vue?vue&type=script&lang=js&"
export * from "./chainAdministrationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports